import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useToggle } from 'hooks/useToggler';

import { SectionWrapper } from 'components/_basic/SectionWrapper/SectionWrapper';
import { DeleteAccountModal } from 'components/DeleteAccountModal/DeleteAccountModal';

export const AccountDelete: FC = () => {
  const { t } = useTranslation();
  const [isDeleteAccountModalOpened, setDeleteAccountModalOpened] = useToggle(false);

  return (
    <>
      <SectionWrapper
        sectionTitle={t('deleteAccount')}
        buttonText={t('delete')}
        buttonClickHandler={() => setDeleteAccountModalOpened(true)}
        buttonVariant="red"
      />
      <DeleteAccountModal 
        isModalOpened={isDeleteAccountModalOpened}
        onModalClose={setDeleteAccountModalOpened}
      />
    </>
  );
};
